import {create} from 'zustand';
import {UseStepPreviewStoreProps} from './types';
import {StepPreviewEnum} from '../../types';

export const useStepPreviewStore = create<UseStepPreviewStoreProps>((set, get) => ({
	step: StepPreviewEnum.BENEFICIARY_DATA,
	setStep: step => set({step}),
	resetStep: () => set({step: StepPreviewEnum.BENEFICIARY_DATA}),
	nextStep: () => set({step: get().step + 1}),
	previousStep: () => set({step: get().step - 1}),
}));
